import { Link } from 'react-router-dom';


const NotFound = () => {
  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <h1>404</h1>
        <h2>Strona nie odnaleziona</h2>
        <p>Przepraszamy, ale szukana przez Ciebie strona nie istnieje.</p>
        <Link to="/" className="notfound-link">Powrót do strony głównej</Link>
      </div>
    </div>
  );
};

export default NotFound;